module.exports = __webpack_public_path__ + "media/application/images/projects/secondary_nav/oil-big-2934edc839d5c98c6cf6adb6fe07f479.jpg";